(() => {
  const mobileQuery = window.matchMedia('(max-width: 989px)');

  function closeDetails(details, controller) {
    if (!details?.open) return;

    if (typeof controller?.close === 'function') {
      controller.close(false);
      return;
    }

    if (typeof controller?.closeMenuDrawer === 'function') {
      const summary = details.querySelector(':scope > summary');
      controller.closeMenuDrawer(new Event('click'), summary);
      return;
    }

    details.classList.remove('menu-opening');
    details.removeAttribute('open');
  }

  function setupHeader(header) {
    if (header.dataset.lusupResponsiveReady === 'true') return;

    const searchController = header.querySelector('details-modal.header__search');
    const searchDetails = searchController?.querySelector(':scope > details');
    const menuController = header.querySelector('header-drawer');
    const menuDetails = menuController?.querySelector(':scope > details');

    if (!searchDetails && !menuDetails) return;

    header.dataset.lusupResponsiveReady = 'true';

    const updateState = () => {
      const searchOpen = Boolean(searchDetails?.open);
      const menuOpen = Boolean(menuDetails?.open);
      const overlayOpen = mobileQuery.matches && (searchOpen || menuOpen);

      header.classList.toggle('lusup-search-open', mobileQuery.matches && searchOpen);
      header.classList.toggle('lusup-menu-open', mobileQuery.matches && menuOpen);
      document.documentElement.classList.toggle('lusup-header-overlay-open', overlayOpen);
    };

    searchDetails?.addEventListener('toggle', () => {
      if (searchDetails.open && menuDetails?.open) {
        closeDetails(menuDetails, menuController);
      }
      updateState();
    });

    menuDetails?.addEventListener('toggle', () => {
      if (menuDetails.open && searchDetails?.open) {
        closeDetails(searchDetails, searchController);
      }
      updateState();
    });

    const handleViewportChange = () => {
      if (!mobileQuery.matches) {
        closeDetails(searchDetails, searchController);
        closeDetails(menuDetails, menuController);
        header.classList.remove('lusup-search-open', 'lusup-menu-open');
        document.documentElement.classList.remove('lusup-header-overlay-open');
      } else {
        updateState();
      }
    };

    mobileQuery.addEventListener?.('change', handleViewportChange);
    updateState();
  }

  function setupAllHeaders(root = document) {
    root.querySelectorAll('.lusup-header-wrapper').forEach(setupHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAllHeaders(), { once: true });
  } else {
    setupAllHeaders();
  }

  document.addEventListener('shopify:section:load', (event) => setupAllHeaders(event.target));
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('.lusup-header-wrapper.lusup-search-open, .lusup-header-wrapper.lusup-menu-open')) {
      document.documentElement.classList.remove('lusup-header-overlay-open');
    }
  });
})();
